/**
 * La carga de una página o de un bloque de datos. No bloquea: es la misma tarjeta que
 * «Procesando…», sin el velo.
 */
export function Cargando({
  titulo = 'Cargando',
  detalle = 'Preparando la información',
  alto = 'h-48',
}: {
  titulo?: string;

  detalle?: string;

  /** El hueco que ocupa mientras carga; si la tarjeta no cabe, crece. */
  alto?: string;
}) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={`${titulo}…`}
      className={`grid ${alto} min-h-fit place-items-center p-4`}
    >
      <div className="w-full max-w-xs rounded-2xl border border-armazon-200 bg-white px-8 py-7 text-center uppercase shadow-xl shadow-armazon-900/5">
        <Rueda />
        <p className="mt-4 text-sm font-bold tracking-wider text-armazon-900">{titulo}…</p>
        <p className="mt-1 text-[11px] font-medium tracking-wide text-armazon-500">{detalle}</p>
        <BarraDeProgreso />
      </div>
    </div>
  );
}

/** Dentro de una tabla o un panel, donde la tarjeta no cabe. */
export function CargandoEnLinea({ detalle }: { detalle?: string }) {
  return (
    <span
      role="status"
      aria-live="polite"
      className="flex flex-col items-center justify-center gap-3 px-6 py-10"
    >
      <Rueda pequenia />
      <span className="text-[11px] font-semibold uppercase tracking-wide text-armazon-500">
        {detalle ?? 'Cargando'}…
      </span>
      <span className="block w-40">
        <BarraDeProgreso fina />
      </span>
    </span>
  );
}

export function Rueda({ pequenia = false, grande = false }: { pequenia?: boolean; grande?: boolean }) {
  const medida = pequenia ? 'size-6 border-[3px]' : grande ? 'size-14 border-4' : 'size-12 border-4';
  return (
    <span
      aria-hidden
      className={`${medida} mx-auto block shrink-0 animate-spin rounded-full border-armazon-100 border-t-marca-600`}
    />
  );
}

export function BarraDeProgreso({ fina = false }: { fina?: boolean }) {
  return (
    <span
      aria-hidden
      className={`${fina ? 'h-1' : 'mt-5 h-1.5'} block overflow-hidden rounded-full bg-armazon-100`}
    >
      <span className="barra-de-progreso block h-full w-1/3 rounded-full bg-marca-600" />
    </span>
  );
}
